import {
  FETCH_BUILDING_CODES,
  FETCH_BUILDING_CODES_SUCCESS,
  FETCH_BUILDING_CODES_FAILURE,
} from "features/yard360/store/buildingCodes/types";

export const INITIAL_BUILDING_CODES_DATA = {
  buildingCodes: null,
  fetchingBuildingCodes: false,
  errorMessage: null,
};

export const buildingCodesReducer = (state = INITIAL_BUILDING_CODES_DATA, action) => {
  switch (action.type) {
    case FETCH_BUILDING_CODES:
      return {
        ...state,
        fetchingBuildingCodes: true,
      };

    case FETCH_BUILDING_CODES_SUCCESS: {
      const { yardIdentifiers } = action.payload;
      return {
        ...state,
        buildingCodes: yardIdentifiers.flatMap(({ buildingCodes }) => buildingCodes).sort(),
        fetchingBuildingCodes: false,
      };
    }

    case FETCH_BUILDING_CODES_FAILURE: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        fetchingBuildingCodes: false,
        errorMessage,
      };
    }

    default:
      return state;
  }
};
